import React from "react";
import { AlcancePerfil } from "../../../../interfaces/Profile";

const ROTULO: Record<string, string> = { interno: "Interno", externo: "Externo", misto: "Misto" };

const COR: Record<string, string> = {
  interno: "bg-brand-500/10 text-brand-500",
  externo: "bg-amber-500/10 text-amber-700 dark:text-amber-400",
  misto: "bg-gray-100 text-gray-600 dark:bg-navy-900 dark:text-gray-400",
};

/** Selo do alcance do perfil. Sem selo para "vazio" e para backend antigo (campo ausente). */
const AlcanceBadge: React.FC<{ alcance?: AlcancePerfil }> = ({ alcance }) => {
  if (!alcance || !ROTULO[alcance]) return null;
  return (
    <span
      aria-label={`Alcance do perfil: ${ROTULO[alcance]}`}
      className={`shrink-0 rounded-lg px-2 py-0.5 text-xs font-medium ${COR[alcance]}`}
    >
      {ROTULO[alcance]}
    </span>
  );
};

export default AlcanceBadge;
